import { RootState } from '../types';
import { storeResources } from '../resources';
import { IPortalConfig, ITechnicianData } from '../../services/config/types';

export const PortalConfigSelector = (state: RootState): IPortalConfig =>
  state[storeResources.CONFIG].config;

export const PortalTechnicianDataSelector = (state: RootState): ITechnicianData =>
  state[storeResources.CONFIG].technicianData;
